import React, { useState, useEffect } from "react";
import { Box, Button, Container, Grid, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams } from "react-router-dom";
import Repo from "../Repository/Repo";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from "@mui/material";

function BillPreview() {
  console.log('od')
  const { id } = useParams();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  const [bill, setBill] = useState("");
  const [company, setCompany] = useState("");
  console.log('bill', bill)
  useEffect(() => {
    getBill();
  }, [id]);

  const getBill = () => {
    Repo.bills({
      request: {
        method: "getBill",
        data: {
          _id: id,
        },
      },
    }).then((res) => {
      let companyCode = res.data.response.data.billObj.company_code;
      Repo.companies({
        request: {
          method: "getCompany",
          data: {
            _id: companyCode,
          },
        },
      }).then(async (response) => {
        const found = response.data.response.data.company.find(
          (item) => item._id == companyCode
        );
        await setCompany(found);
      });

      setBill(res.data.response.data.billObj);
    });
  };

  return (
    <Box sx={{ backgroundColor: "white", height: "200vh" }}>
      <Container>
        <div className="header">
          <Grid container sx={{justifyContent:"space-between"}}>
            <Grid item lg={10} md={10} sm={10} xs={10}>
              {matches ? (
                <h1>{company && company.company_name}</h1>
              ) : (
                <h3>{company && company.company_name}</h3>
              )}
            </Grid>
            <Grid item lg={1} md={1} sm={1} xs={1}>
              <Button
                style={{
                  float: "right",
                  backgroundColor: "transparent",
                  textTransform: "none",
                  marginTop: "30px",
                }}
                onClick={() => {
                  window.print();
                }}>
                Print
              </Button>
            </Grid>
          </Grid>
        </div>

        <div
          style={{
            float: "right",
            display: "inline",
            padding: "none",
            marginBottom: "10px",
            marginRight: "30px",
          }}>
          {matches ? (
            <h1 style={{ padding: "0px", margin: "0px" }}>Bill Details</h1>
          ) : (
            <h3 style={{ padding: "0px", margin: "0px" }}>Bill Details</h3>
          )}

          <h5 style={{ padding: "0px", margin: "0px" }}>
            Date : {bill && bill.date}
          </h5>
          <h5 style={{ padding: "0px", margin: "0px" }}>
            Bill Number : {bill && bill.billNumber}
          </h5>
        </div>
        <Grid container style={{ marginBottom: "10px" }}>
          <Grid item lg={5} md={5} sm={5} xs={5}>
            <div style={{ backgroundColor: "#4caf50" }}>
              <h3 style={{ padding: "0px", margin: "0px" }}>Store</h3>
            </div>
            <p style={{ padding: "0px", margin: "0px" }}>
              {company && company?.company_name}
            </p>
            <p style={{ padding: "0px", margin: "0px" }}>
              {company && company?.address?.street}{" "}
              {company && company?.address?.city}
            </p>

            <p style={{ padding: "0px", margin: "0px" }}>
              {company && company?.address?.phone}
            </p>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2}></Grid>
          <Grid item lg={5} md={5} sm={5} xs={5}>
            <div style={{ backgroundColor: "#4caf50" }}>
              <h3 style={{ padding: "0px", margin: "0px" }}>Customer</h3>
            </div>
            <p style={{ padding: "0px", margin: "0px" }}>
              {" "}
              {bill && bill.customer}
            </p>
          </Grid>
        </Grid>

        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">#</TableCell>
              <TableCell align="left">Item</TableCell>
              <TableCell align="left">Description</TableCell>
              <TableCell align="left">Quantity</TableCell>
              <TableCell align="left">Price</TableCell>
              <TableCell align="left">Total Price</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bill &&
              bill.items.map((item, index) => (
                <TableRow key={item._id}>
                  <TableCell className="bill-heading">{index}</TableCell>
                  <TableCell className="bill-heading">{item.name}</TableCell>
                  <TableCell className="bill-heading">
                    {item?.description}
                  </TableCell>
                  <TableCell className="bill-heading">
                    {item?.saleQuantity}
                  </TableCell>
                  <TableCell className="bill-heading">{item?.price}</TableCell>
                  <TableCell className="bill-heading">
                    {parseInt(item?.saleQuantity) * parseInt(item?.price)}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        <Grid container style={{ marginTop: "50px", marginBottom: "20px" }}>
          <Grid item lg={1} sm={1} xs={1}></Grid>
          <Grid item lg={5} sm={5} xs={5}>
            <div
              style={{
                border: "solid 1px",
                marginBottom: "5px",
                textAlign: "center",
              }}>
              {matches ? (
                <h3 style={{ padding: "0px", margin: "0px" }}>
                  Comments Or Special Instruction
                </h3>
              ) : (
                <h5 style={{ padding: "0px", margin: "0px" }}>
                  Comments Or Special Instruction
                </h5>
              )}
            </div>
            <div style={{ border: "solid 1px", height: "200px" }}></div>
          </Grid>
          <Grid item lg={1} sm={1} xs={1}></Grid>
          <Grid style={{ marginLeft: "20px" }} item lg={2} sm={2} xs={2}>
            {matches ? (
              <>
                <h3 style={{ padding: "0px", margin: "0px" }}>Sub Total :</h3>
                <h3 style={{ padding: "0px", margin: "0px" }}>Discount :</h3>
                <h3 style={{ padding: "0px", margin: "0px" }}>Change : </h3>
                <h3 style={{ padding: "0px", margin: "0px" }}>Paid : </h3>
                <h3 style={{ padding: "0px", margin: "0px" }}>Total : </h3>
              </>
            ) : (
              <>
                <h5 style={{ padding: "0px", margin: "0px" }}>Sub Total :</h5>
                <h5 style={{ padding: "0px", margin: "0px" }}>Discount :</h5>
                <h5 style={{ padding: "0px", margin: "0px" }}>Change : </h5>
                <h5 style={{ padding: "0px", margin: "0px" }}>Paid : </h5>
                <h5 style={{ padding: "0px", margin: "0px" }}>Total : </h5>
              </>
            )}
          </Grid>
          <Grid item lg={2} sm={2} xs={2}>
            {matches ? (
              <>
                <h3 style={{ padding: "0px", margin: "0px" }}>
                  {(bill && bill.subTotal) ?? 0}
                </h3>
                <h3 style={{ padding: "0px", margin: "0px" }}>
                {(bill && (bill.discount)) ? bill.discount  : 0}
                </h3>
                <h3 style={{ padding: "0px", margin: "0px" }}>
                  {(bill && bill.change) ?? 0}
                </h3>
                <h3 style={{ padding: "0px", margin: "0px" }}>
                  {(bill && bill.paid) ?? 0}
                </h3>
                <h3 style={{ padding: "0px", margin: "0px" }}>
                  {(bill && bill.total) ?? 0}
                </h3>
              </>
            ) : (
              <>
                <h5 style={{ padding: "0px", margin: "0px" }}>
                  {(bill && bill.subTotal) ?? 0}
                </h5>
                <h5 style={{ padding: "0px", margin: "0px" }}>
                  {(bill && (bill.discount)) ? bill.discount  : 0}
                </h5>
                <h5 style={{ padding: "0px", margin: "0px" }}>
                  {(bill && bill.change) ?? 0}
                </h5>
                <h5 style={{ padding: "0px", margin: "0px" }}>
                  {(bill && bill.paid ) ?? 0}
                </h5>
                <h5 style={{ padding: "0px", margin: "0px" }}>
                  {(bill && bill.total) ?? 0}
                </h5>
              </>
            )}
          </Grid>
        </Grid>
        {/* <div id="bill-preview-footer">
          <h5 style={{ padding: "0px", margin: "0px" }} align="center">
            Powereds by www.hardwarepakistan.com
          </h5>
          <h5
            style={{ padding: "0px", margin: "0px", paddingBottom: "10px" }}
            align="center">
            0342-5588269
          </h5>
        </div> */}
      </Container>
    </Box>
  );
}

export default BillPreview;
